import React, { Component } from "react";
import Dialog from "@material-ui/core/Dialog";
import { withRouter } from "react-router-dom";

class UpdateModal extends Component {
  render() {
    const currentPath = this.props.location.pathname;
    
    // Check if we're on a delivery route - exclude from delivery
    const isDeliveryRoute = currentPath.startsWith("/delivery");
    
    // Only show on home screen routes (root "/" or "/home-front")
    // HomeFront is rendered by Mobile component on root "/" when user has address
    // Also check if we're on the actual home-front route
    const isHomeRoute = currentPath === "/" || currentPath === "/home-front";
    
    // Don't show modal on delivery routes or non-home routes
    if (isDeliveryRoute || !isHomeRoute) {
      return null;
    }

    return (
      <Dialog
        fullScreen={true}
        open={true}
        disableBackdropClick={true}
        disableEscapeKeyDown={true}
        PaperProps={{
          style: {
            backgroundColor: "#fff",
            margin: 0,
            maxWidth: "100%",
            width: "100%",
            height: "100%",
          },
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
            width: "100vw",
            padding: "20px",
            textAlign: "center",
          }}
        >
          <div style={{ marginBottom: "30px" }}>
            <h1
              style={{
                fontSize: "24px",
                fontWeight: "bold",
                marginBottom: "20px",
                color: "#333",
              }}
            >
              Update Required
            </h1>
            <p
              style={{
                fontSize: "16px",
                color: "#666",
                marginBottom: "40px",
              }}
            >
              Please update the app to continue using Pykin.
            </p>
          </div>
          <a
            href="https://pykin.onelink.me/H0wS/download"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "inline-block",
              padding: "15px 40px",
              backgroundColor: localStorage.getItem("storeColor") || "#ED0101",
              color: "#fff",
              textDecoration: "none",
              borderRadius: "8px",
              fontSize: "18px",
              fontWeight: "bold",
              cursor: "pointer",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            }}
          >
            UPDATE NOW
          </a>
        </div>
      </Dialog>
    );
  }
}

export default withRouter(UpdateModal);

